module.exports = __webpack_public_path__ + "static/media/3DMODEL2.504a755.glb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vi/3DMODEL2.glb
// module id = FUzb
// module chunks = 1